module.exports = "/cyber/_next/static/images/inariusResult-95faca1aaaab5901d9c103a061fc6ddb.jpg";